<template>
  <div
    class="col-6 col-lg-4"
    v-for="(conf, i) in selectedConfig.craft"
    :key="i"
  >
    <div class="crafting-tool_group">
      <div class="crafting-img img-frame">
        <img
          :src="`/images/gameitem/${conf.key}.png`"
          class="img-fluid"
          alt=""
        />
      </div>
      <span
        v-if="conf.key == 'WWS' || conf.key == 'WWG'"
        :class="tokenAvailable(conf.key, conf.value)"
        >{{ conf.key + " " + conf.value }}</span
      >
      <span v-else :class="isOkey(conf.key, conf.value)">{{
        gameItemsObj[conf.key] + " " + conf.value
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["wwsToken", "gameItems", "wwgToken"]),
  },
  name: "CraftConfig",
  props: ["selectedConfig", "gameItemsObj"],
  mounted() {
    console.log(this.gameItems);
  },
  methods: {
    isOkey(item, val) {
      if (this.gameItems.length) {
        let itemname = this.gameItems.filter((row) => row.key.includes(item));
        if (itemname.length && itemname[0].value >= val) {
          return "text-success";
        } else {
          return "text-gray";
        }
      }
      return "text-default";
    },
    tokenAvailable(item, val) {
      if (item == "WWS" && this.wwsToken >= val) {
        return "text-success";
      } else if (item == "WWG" && this.wwgToken >= val) {
        return "text-success";
      }
      return "text-default";
    },
  },
};
</script>
<style scoped>
.crafting-tool-wrapper {
  padding: 4px 50px;
  height: 180px;
  overflow-y: scroll;
}
.crafting-tool_group {
  margin-top: 5px;
}

.crafting-tool_group span {
  display: inline-block;
}
.crafting-tool_group .crafting-img {
  /* width: 80px; */
  margin: auto;
}
.crafting-tool_group .crafting-img img {
  aspect-ratio: 3/3;
  object-fit: contain;
}
@media (max-width: 768px) {
  .crafting-tool_group .crafting-img {
    width: 80px;
  }
}
</style>
